import { __extends } from "tslib";
import { UpdateApnsVoipChannelRequest, UpdateApnsVoipChannelResponse } from "../models/models_1";
import { deserializeAws_restJson1UpdateApnsVoipChannelCommand, serializeAws_restJson1UpdateApnsVoipChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateApnsVoipChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateApnsVoipChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateApnsVoipChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateApnsVoipChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "UpdateApnsVoipChannelCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: UpdateApnsVoipChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateApnsVoipChannelResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateApnsVoipChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateApnsVoipChannelCommand(input, context);
    };
    UpdateApnsVoipChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateApnsVoipChannelCommand(output, context);
    };
    return UpdateApnsVoipChannelCommand;
}($Command));
export { UpdateApnsVoipChannelCommand };
//# sourceMappingURL=UpdateApnsVoipChannelCommand.js.map